import React from 'react';
import { 
    Dialog,
    IconButton,
    Typography,
    DialogTitle,
    Button
} from "@material-ui/core/";
import CloseIcon from '@material-ui/icons/Close';
import TagManager from 'react-gtm-module';
import arquivo from "../assets/portal-do-fornecedor-emissao-etiqueta-de-expedicao_manual-de-etiquetas.pdf";

//css
import Styles from './styles';
const useStyles = Styles();

export default({modalManual,setModalManual})=>{
    const classes = useStyles();

    const HeaderModal = () => {
        return(
            <div className={classes.headerModal}>
                <IconButton
                    aria-label="close"
                    className={classes.closeButton}
                    onClick={()=>{setModalManual(false)}}
                >
                    <CloseIcon />
                </IconButton>
                <Typography variant="h6" align="center">
                    {"Manual de Etiquetas"}
                </Typography>
            </div>
        )
    };

    const DownloadFile = () => {
        TagManager.dataLayer({
            dataLayer: {
              event: 'event',
              eventCategory: 'tokstok:fornecedores:gerenciar-pedido',
              eventAction: 'clique:botao',
              eventLabel: 'manual-etiquetas',
            }
        });
    };

    const ButtonConfirm = () => {
        return (
            <div className={classes.footerSpace} align="center">
                <Button
                    onClick={DownloadFile}
                    type="submit"
                    variant="contained"
                    color="primary"
                    href={arquivo}
                    download="Manual de Etiquetas TokStok.pdf"
                >
                    <i className="material-icons">file_download</i>
                    {"Baixar Manual de Etiquetas"}
                </Button>
            </div>
        );
    };

    return (
        <div>
            <Dialog
                open={modalManual}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth
                maxWidth = {"md"}
            >
                <DialogTitle>
                    <HeaderModal/>
                </DialogTitle>
                <object width="100%" className={classes.pdfView} type="application/pdf" data={arquivo+"#view=Fith&toolbar=0&navpanes=0"}>
                    <Typography variant="h6" align="center" >O documento não pode ser visualizado neste dispositivo.</Typography>
                </object>
                <Typography style={{ padding: "10px"}} align="center">
                    <ButtonConfirm/>
                </Typography>

            </Dialog>
        </div>
    );
};
